import React, { FC } from 'react';
import { LawFirmPopoverInfos } from '../lawFirm.types';
import { EntitiesListItem } from '../../components/entities-card/EntitiesList';
import { numberWithSpaces } from '../../utils/math';

type Props = {
  lawFirm: LawFirmPopoverInfos;
};

export const LawFirmDetails: FC<Props> = ({ lawFirm }) => (
  <>
    {lawFirm.postalCity && (
      <EntitiesListItem left="Ville" right={lawFirm.postalCity} />
    )}
    {lawFirm.nbLawyers > 0 && (
      <EntitiesListItem
        left="Nombre d'avocats référencés"
        right={`${numberWithSpaces(lawFirm.nbLawyers)} avocat${
          lawFirm.nbLawyers > 1 ? 's' : ''
        }`}
      />
    )}
  </>
);
